import { Injector } from '@angular/core';
import { FiChatService } from '@fi-shared/fi-chat/fi-chat.service';

import { IPersonalNotificationsItem } from '@fi-app/personal-notifications/personal-notifications';

export class PersonalNotificationListItemBase {
    private fiChatService: FiChatService;

    constructor(protected injector: Injector) {
        this.fiChatService = injector.get(FiChatService);
    }

    protected handleChatConversationItemClick(listItem: IPersonalNotificationsItem) {
        this.fiChatService.triggerOpenConversationByIdWithAccessCheck(listItem.ObjectId);
    }
}
